<script>
  import { onMount } from "svelte";
  import { result } from "../store.js";

  export let item = {
    type: "text",
    min: 1,
    max: 50,
    required: false,
    title: "",
    description: "",
    placeholder: "",
  };
  export let index = 0;

  onMount(() => {
    $result[index] = "";
  });
</script>

<input
  type="text"
  required={item.required}
  placeholder={item.placeholder || ""}
  bind:value={$result[index]}
/>

<style>
  input {
    width: 100%;
  }
</style>
